module.exports = __webpack_public_path__ + "img/52114138_L.eb880326.png";